import Hero from '../components/Hero'
import './ESG.css'

const ESG = () => {
  return (
    <>
      {/* Hero */}
      <Hero 
        title="Environmental, Social & Governance (ESG)"
        subtitle="Creating positive impacts for people, communities and the planet."
        backgroundImage="/esg/esg.png"
        height="55.78125vh"
      />

      {/* Overview */}
      <section>
        <div className="section-header">
          <h2>Our ESG Commitment</h2>
        </div>
        <p>We are dedicated to operating responsibly by managing our environmental impact, upholding strong social values, and ensuring transparent governance. Our approach focuses on reducing emissions and waste, fostering diversity and fairness across our workforce and supply chains, and maintaining the highest standards of accountability, ethics, and compliance to deliver long-term value for all stakeholders.</p>
        <div className="esg-grid">
          <article>
            <h3>Environmental</h3>
            <p>We prioritise sustainability through eco-friendly products, waste reduction initiatives, and continuous innovation to minimise our environmental footprint. Our operations focus on reducing emissions and implementing sustainable practices across all our services.</p>
          </article>
          <article>
            <h3>Social</h3>
            <p>We foster diversity, equity, and inclusion across our workforce and supply chains. We invest in our team through inclusive hiring, continuous training, and career development while supporting local communities and charitable initiatives.</p>
          </article>
          <article>
            <h3>Governance</h3>
            <p>We maintain the highest standards of accountability, ethics, and compliance. Our transparent governance framework ensures ethical business practices, regulatory compliance, and stakeholder trust through clear communication and responsible decision-making.</p>
          </article>
          <article>
            <h3>Stakeholder Value</h3>
            <p>We recognise that sustainable business practices enable us to deliver long-term value for all stakeholders. We conduct business transparently and ethically to build lasting relationships with clients, employees, and communities.</p>
          </article>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <h2>Join Our Mission</h2>
        <p>We're committed to creating sustainable value for our clients and communities. Partner with us to build a better future.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default ESG
